// extracted by mini-css-extract-plugin
export var video_thumb_wrapper = "styles-module--video_thumb_wrapper--a4930";
export var video_title = "styles-module--video_title--73a0d";
export var video_watch_now = "styles-module--video_watch_now--31543";